/* Histemo 2026: product cards, routine tabs, toggles */
(function(){
  function refreshCart(){
    fetch('/?sections=cart-icon-bubble').then(function(r){return r.json()}).then(function(s){
      var el=document.getElementById('cart-icon-bubble'); if(el && s['cart-icon-bubble']){var d=document.createElement('div'); d.innerHTML=s['cart-icon-bubble']; var n=d.querySelector('.shopify-section'); el.innerHTML=(n||d).innerHTML;}
    }).catch(function(){});
  }
  window.hsRefreshCart=refreshCart;
  document.addEventListener('click',function(e){
    var sz=e.target.closest('[data-hs-size]');
    if(sz){var card=sz.closest('[data-hs-card]'); card.querySelectorAll('[data-hs-size]').forEach(function(b){b.setAttribute('aria-pressed',b===sz?'true':'false')});
      card.querySelector('[data-hs-price]').innerHTML=sz.dataset.price; card.querySelector('[data-hs-add]').dataset.id=sz.dataset.id; return;}
    var add=e.target.closest('[data-hs-add]');
    if(add){add.disabled=true; var t=add.textContent; add.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+add.dataset.id,quantity:1}]})})
      .then(function(r){if(!r.ok)throw 0; add.textContent='Added ✓'; add.classList.add('is-added'); refreshCart(); setTimeout(function(){add.textContent=t; add.classList.remove('is-added'); add.disabled=false},2200)})
      .catch(function(){add.textContent='Try again'; add.disabled=false}); return;}
    var tab=e.target.closest('[data-hs-tab]');
    if(tab){var g=tab.closest('[data-hs-tabs]'); var k=tab.dataset.hsTab;
      g.querySelectorAll('[data-hs-tab]').forEach(function(b){b.setAttribute('aria-selected',b===tab?'true':'false')});
      g.querySelectorAll('[data-hs-panel]').forEach(function(p){p.classList.toggle('is-on',p.dataset.hsPanel===k)}); }
  });
})();
